<template>
  <div class="menu-main">
    <div class="header-container">
      <div class="btn-group" v-permission="['sys:whitelist:add']">
        <el-button
          icon="el-icon-plus"
          size="small"
          type="primary"
          @click="uiControl.dialogVisible=true"
        >
          Add
        </el-button>
      </div>
    </div>
    <el-dialog
      title="add Whitelist"
      v-model="uiControl.dialogVisible"
      append-to-body
      width="600px"
      @close="uiControl.popoverVisible = false"
      destroy-on-close
    >
      <el-form
        ref="menuForm"
        :model="form"
        :rules="formRules"
        :inline="true"
        size="small"
        label-width="150px"
      >
        <el-form-item label="Ip" prop="ip">
          <el-input v-model="form.ip" style="width: 300px" />
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" @click="uiControl.dialogVisible=false">Cancel</el-button>
        <el-button size="small" @click="submit" type="primary">
          Confirm
        </el-button>
      </div>
    </el-dialog>

    <!-- eslint-disable -->
    <el-table
      :data="list"
      style="width: 100%"
      size="small"
      row-key="id"
      ref="treeTable"
      lazy
      :key="tableKey"
      :cell-class-name="cellGrayWhite"
    >
      <el-table-column
        prop="ip"
        label="ip"
        align="left"
      />
      <el-table-column label="operate" align="center">
        <template #default="scope">
          <el-button v-permission="['sys:whitelist:delete']"
                     icon="el-icon-remove"
                     size="small"
                     type="danger"
                     @click="removeMenu(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  getWhitelist, addWhitelist, deleteWhitelist
} from '../../../api/site-ip-whitelist'
import { cellGrayWhite } from '@/utils/style'
import { required } from "../../../utils/validate";

const list = reactive([])
const menuForm = ref(null)
const form = reactive({
  ip: null,
})
const formRules = reactive({
  ip: [required('ip is require')],
})
const uiControl = reactive({
  dialogVisible: false,
  popoverVisible: false,
  dialogTitle: '',
  dialogType: 'CREATE',
})

async function loadWhitelist() {
  const { data: ret } = await getWhitelist()
  list.length = 0
  list.push(...ret)
}

function submit() {
  menuForm.value.validate(async valid => {
    if (valid) {
      await addWhitelist(form)
      await loadWhitelist()
      uiControl.dialogVisible = false
      ElMessage({ message: 'Add Successful', type: 'success' })
    }
  })
}

function removeMenu(data) {
  ElMessageBox.confirm(`Delete ${data.ip}?`, {
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    type: 'warning',
  }).then(async () => {
    await deleteWhitelist(data.id)
    loadWhitelist()
    ElMessage({ message: 'Delete Successful', type: 'success' })
  })
}

onMounted(() => {
  loadWhitelist()
})
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.header-container {
  margin-bottom: 10px;
}

.search {
  display: flex;
  justify-content: flex-start;
}

.btn-group {
  margin-top: 15px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.el-table--enable-row-transition .el-table__body td.el-table__cell {
  padding: 4px 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
